import { render } from "./ExamsView.vue?vue&type=template&id=3d00254e&scoped=true"
import script from "./ExamsView.vue?vue&type=script&lang=js"
export * from "./ExamsView.vue?vue&type=script&lang=js"

import "./ExamsView.vue?vue&type=style&index=0&id=3d00254e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d00254e"]])

export default __exports__